import { useState, useEffect, type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Avatar, Tooltip } from 'shared/ui'
import { TrialContactsLimitTooltipStore } from 'entities/Subscription/ui/TrialContactsLimitTooltip/store/trialContactsLimitTooltipStore'
import { useEntitiesContext } from 'entities/EntitiesExport'

type ITrialTooltipContactsProps = {
  show: boolean
}

export const TrialContactsLimitTooltip: FC<ITrialTooltipContactsProps> = observer(({ show }) => {
  const entities = useEntitiesContext()
  const [store] = useState(() => new TrialContactsLimitTooltipStore(entities))

  useEffect(() => {
    store.init()
  }, [])

  if (!show) return null
  if (store.hide) return null

  const lockAvatar = (
    <Avatar
      info={{
        icon: 'lock',
      }}
      size={24}
    />
  )

  if (!store.isTrial) return lockAvatar

  return <Tooltip {...store.configTooltip}>{lockAvatar}</Tooltip>
})
